import { isNotEmptyNumber } from '@/utils/checkValue/number';
import { isNullOrUndefinedOrEmpty } from '@/utils/checkValue/string';
/**
 * 整数か
 * @param text エラー文言
 */
export const isInteger = (text) => (value) => {
    const stringValue = typeof value === 'number' ? `${value}` : value;
    if (isNullOrUndefinedOrEmpty(stringValue)) {
        return undefined;
    }
    return String(stringValue).match(/^\d+$/) ? undefined : text;
};
/**
 * 値が範囲内にある
 * @param min 最小値
 * @param max 最大値
 * @param text エラー文言
 * @returns {Function}
 */
export const isNumberWithinRange = (min, max, text) => (value) => {
    const numberValue = typeof value === 'string' ? parseInt(value, 10) : value;
    if (!isNotEmptyNumber(numberValue)) {
        return undefined;
    }
    return numberValue >= min && numberValue <= max ? undefined : text;
};
/**
 * 値が最小値より大きいか
 * @param min 最小値
 * @param text エラー文言
 * @returns {Function}
 */
export const isMore = (min, text) => (value) => {
    const numberValue = typeof value === 'string' ? parseInt(value, 10) : value;
    if (!isNotEmptyNumber(numberValue)) {
        return undefined;
    }
    return numberValue > min ? undefined : text;
};
